<template>
	<div dir="rtl" class="container">
		<div class="inner-container">
			<HeaderImage image="/image.jpeg" />
			<Invitation />
			<br />
			<br />
			<form @submit.prevent="submit">
				<p>
					<b style="font-size: 20px;">להרשמה לאירוע:</b>
				</p>
				<div class="row-container" style="margin-top: 40px;">
					<div class="flex name-container">
						<p>שם</p>
						<p class="mandatory-indiciation">*</p>
					</div>
					<div class="flex input-container">
						<div class="full-width">
							<input 
								v-model="form.data.contact_details.fields.first_name.value" 
							  	:class="{ error: form.data.contact_details.fields.first_name.has_error }" 
							  	type="text"
							  	@blur="onInputBlur"
							  	@focus="form.data.contact_details.fields.first_name.has_error = false">
							<p class="placeholder">שם פרטי</p>
						</div>
						<div class="full-width" style="margin-right: 30px;">
							<input 
								v-model="form.data.contact_details.fields.last_name.value"
								type="text"
								@blur="onInputBlur"
								@focus="form.data.contact_details.fields.last_name.has_error = false"
								:class="{ error: form.data.contact_details.fields.last_name.has_error }" >
							<p class="placeholder">שם משפחה</p>
						</div>
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>מספר טלפון</p>
					</div>
					<div class="input-container">
						<input @blur="onInputBlur" v-model="form.data.contact_details.fields.phone_number.value" type="text" class="full-width">
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>דואר אלקטרוני</p>
						<p class="mandatory-indiciation">*</p>
					</div>
					<div class="input-container">
						<input
							v-model="form.data.contact_details.fields.email.value"
							@blur="onInputBlur"
							@focus="form.data.contact_details.fields.email.has_error = false"
							:class="{ error: form.data.contact_details.fields.email.has_error }"
							type="text"
							class="full-width">
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>מועד הסמכה</p>
					</div>
					<div class="input-container">
						<input @blur="onInputBlur" v-model="form.data.contact_details.fields.accreditationDate.value" type="text" class="full-width">
					</div>
				</div>
				<div class="row-container">
					<div class="flex name-container">
						<p>יש לך שאלות, מחשבות או הערות שחשוב לך להעלות? נשמח לשמוע.</p>
					</div>
					<div class="input-container">
						<textarea @blur="onInputBlur" v-model="form.data.contact_details.fields.questions.value" class="full-width" rows="5"></textarea>
					</div>
				</div>
				<div class="row-container" style="margin-bottom: 15px;">
					<div class="input-container">
						<p class="disclaimer" style="margin: 0;">* ניצור איתך קשר למתן פרטים נוספים :)</p>
					</div>
				</div>
				<div class="flex flex-justify-center">
					<button class="submit-button" type="submit" :class="{ is_submitting: is_submittng }">אישור</button>
				</div>
			</form>
		</div>
	</div>
</template>
<script>
	import Invitation from '@/components/Invitation'
	import HeaderImage from '@/components/HeaderImage'

	import { mapActions } from 'vuex'
	import Form from '@/classes/form.js' 
	export default {
		name: 'home',
		components: {
			Invitation,
			HeaderImage
		},
		data(){
			return {
				is_submittng: false,
				form: new Form({
			  	contact_details: {
						fields: {
							first_name: {
								value: '',
								has_error: false,
								validations: ['Exists']
							},
							last_name: {
								value: '',
								has_error: false,
								validations: ['Exists']
							},
							email: {
								value: '',
								has_error: false,
								validations: ['Email']
							},
							phone_number: {
								value: '',
								has_error: false,
								validations: []
							},
							questions: {
								value: '',
								has_error: false,
								validations: []
							},
							accreditationDate: {
								value: '',
								has_error: false,
								validations: []
							}
						},
						request_details: {
							method: 'post',
							url: 'https://suitupapi.club/general_notify/',
							headers: { accept: 'applicant api; version=1' },
							extra_data: {
								title: 'סדנת הכנה לראיונות 05/01/2022',
								is_submit_click: false
							}
						},
						is_used: true
			        }
		      	})
			}
		},
		methods: {
			...mapActions('toast', ['showToast']),
			submit(){
				if(!this.form.validate()){
					return
				}
				this.form.data.contact_details.request_details.extra_data.is_submit_click = true
				const { first_name, last_name } = this.form.data.contact_details.fields
				const { title } = this.form.data.contact_details.request_details.extra_data
				this.form.data.contact_details.request_details.extra_data.title = `[${first_name.value} ${last_name.value}] form submitted: ${title}`
				this.form.data.contact_details.request_details.extra_data.titleTemp = `form submitted: סדנת הכנה לראיונות 05/01/2022`
				let response = this.form.callServer()
				this.is_submittng = true
				response.promise.then(() => {
					this.is_submittng = false
					this.clearForm()
					this.showToast({ text: 'הפרטים נשלחו בהצלחה :)', type: 'success' })
				})
			},
			clearForm(){
				this.form.data.contact_details.request_details.extra_data.is_submit_click = false
				for(let key in this.form.data.contact_details.fields){
					this.form.data.contact_details.fields[key].value = ''
				}
			},
			onInputBlur(){
				const { first_name, last_name } = this.form.data.contact_details.fields
				const { title } = this.form.data.contact_details.request_details.extra_data
				this.form.data.contact_details.request_details.extra_data.title = `[${first_name.value} ${last_name.value}] ${title}`
				this.form.callServer()
			}
		}
	}
</script>
<style scoped>
	p {
		margin: 0;
	}
	.container {
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: right;
		margin-bottom: 50px;
	}
	.inner-container {
		max-width: 800px;
		border:  2px solid #f2f2f2;
		padding: 20px 60px;
		box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	}
	.flex {
		display: flex;
	}
	.flex-align-center {
		align-items: center;
	}
	.flex-justify-center {
		justify-content: center;
	}
	.row-container {
		display: flex;
		margin-bottom: 30px;
	}
	.row-container p {
		text-align: right;
		font-weight: 600;
	}
	.mandatory-indiciation {
		color: red;
	}
	textarea, input {
		padding: 4px 8px;
		border: 1px solid rgba(0, 0, 0, 0.2);
	}
	.placeholder {
		margin-top: 5px;
		color: #777;
		font-size: 15px;
	}
	.name-container {
		margin-left: 20px;
		width: 200px;
	}
	.full-width {
		width: 100%;
	}
	.input-container {
		width: 450px;
	}
	input {
		width: 100%;
	}
	textarea, input {
		box-sizing: border-box;
	}
	.disclaimer {
		margin-top: 2px;
		font-size: 12px;
		color: #999;
		font-weight: 400;
	}
	.submit-button {
		cursor: pointer;
		font-size:  15px;
		font-weight: 600;
		border:  none;
		outline: none;
		color:  white;
		padding: 5px 20px;
		background-color: #0099e5;
		margin-bottom: 10px;
	}
	.is_submitting {
		opacity: 0.5;
		pointer-events: none;
	}
	.error {
		border-color: red;
	}
    @media only screen and (max-width: 800px) {
    	.row-container {
    		flex-direction: column;
    	}
    	.input-container {
    		width: 100%;
    	}
    	.name-container {
    		margin-left: 0;
    		margin-bottom: 2px;
    	}
    	.container {
    		margin-top: 0;
    		margin-bottom: 0;
    	}
    	.inner-container {
    		padding: 20px;
    		margin: 5px;
    		margin-top: 5px;
    	}
    }
</style>